// Generated by purs version 0.15.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
import * as PartyCarlo_Capability_Random from "../PartyCarlo.Capability.Random/index.js";
import * as PartyCarlo_Data_Display from "../PartyCarlo.Data.Display/index.js";
import * as PartyCarlo_Data_Probability from "../PartyCarlo.Data.Probability/index.js";
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Effect.bindEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var replicateM = function (dictApplicative) {
    var sequence1 = sequence(dictApplicative);
    return function (n) {
        return function (m) {
            return sequence1(Data_Array.replicate(n)(m));
        };
    };
};
var randoms = function (dictRandom) {
    var replicateM1 = replicateM(((dictRandom.MonadEffect0()).Monad0()).Applicative0());
    var random = PartyCarlo_Capability_Random.random(dictRandom);
    return function (n) {
        return replicateM1(n)(random);
    };
};
var randomEff = /* #__PURE__ */ (function () {
    var tillValid = function (n) {
        return Data_Either.either(Data_Function["const"](bindFlipped(tillValid)(Effect_Random.random)))(pure)(PartyCarlo_Data_Probability.mkProbability(n));
    };
    return bindFlipped(tillValid)(Effect_Random.random);
})();
var note = function (e) {
    return Data_Maybe.maybe(new Data_Either.Left(e))(Data_Either.Right.create);
};
var noteT = function (dictMonadError) {
    var liftEither = Control_Monad_Error_Class.liftEither(dictMonadError.MonadThrow0());
    return function (e) {
        var $35 = note(e);
        return function ($36) {
            return liftEither($35($36));
        };
    };
};
var mapLeft = function (f) {
    return Data_Either.either(function ($37) {
        return Data_Either.Left.create(f($37));
    })(Data_Either.Right.create);
};
var if$prime = function (cond) {
    return function (x) {
        return function (y) {
            if (cond) {
                return x;
            };
            return y;
        };
    };
};
var displayTrunc = function (dictDisplay) {
    var display = PartyCarlo_Data_Display.display(dictDisplay);
    return function (n) {
        return function (x) {
            var s = display(x);
            var substr = Data_String_CodePoints.take(n)(s);
            var $33 = substr === s;
            if ($33) {
                return substr;
            };
            return substr + "...";
        };
    };
};
var cycleUp = function (dictBoundedEnum) {
    var bottom = Data_Bounded.bottom(dictBoundedEnum.Bounded0());
    var succ = Data_Enum.succ(dictBoundedEnum.Enum1());
    return function (x) {
        return Data_Maybe.fromMaybe(bottom)(succ(x));
    };
};
var cycleDown = function (dictBoundedEnum) {
    var top = Data_Bounded.top(dictBoundedEnum.Bounded0());
    var pred = Data_Enum.pred(dictBoundedEnum.Enum1());
    return function (x) {
        return Data_Maybe.fromMaybe(top)(pred(x));
    };
};
var count = function (dictFoldable) {
    var foldl = Data_Foldable.foldl(dictFoldable);
    return function (f) {
        return foldl(function (total) {
            return function (x) {
                var $34 = f(x);
                if ($34) {
                    return total + 1 | 0;
                };
                return total;
            };
        })(0);
    };
};
export {
    mapLeft,
    note,
    noteT,
    replicateM,
    count,
    if$prime,
    displayTrunc,
    cycleUp,
    cycleDown,
    randomEff,
    randoms
};
